import React, { useEffect, useState } from "react"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import { useParams, useNavigate } from "react-router-dom"
import {
  createuploadLinkStart,
  getUploadedFileStart,
  uploadFileStart,
  uploadRefFiles,
  viewRefFiles,
} from "store/actions"
import { useDispatch, useSelector } from "react-redux"
import { createSelector } from "reselect"
import { ToastContainer, toast } from "react-toastify"
import FileTable from "./FileTable"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import CreateUploadFileLink from "./CreateUploadFileLink"
const RefFiles = () => {
  const [modal, setModal] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)

  const navigate = useNavigate()

  const { id } = useParams()
  const dispatch = useDispatch()
  const { loading, responseMsg, error } = useSelector(
    state => state.ReferenceReducer
  )
  

  const toggleModal = () => {
    setModal(!modal)
    setSelectedFile(null)
  }

  const handleUploadFile = () => {
    if (selectedFile === null) {
      toast.error("Please Select File")
    } else {
      const formdata = new FormData();
      formdata.append("reference_id", id);
      formdata.append("files", selectedFile);

      console.log(selectedFile)
      dispatch(uploadRefFiles(formdata))
    }
  }

  useEffect(() => {
    if (responseMsg && responseMsg !== "") {
      toast.success(responseMsg)
      dispatch(viewRefFiles({ reference_id: id }))
      toggleModal()
      setSelectedFile(null)
    }
  }, [responseMsg])

  useEffect(() => {
    if (error && error !== "") {
      toast.error(error)
    }
  }, [error])


  useEffect(() => {
    dispatch(viewRefFiles({ reference_id: id }))
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between">
                <Button
                  onClick={() => navigate(-1)}
                  color="primary"
                  id="backBtn"
                >
                  <FontAwesomeIcon icon={faArrowLeft} className="back-arrow" />
                </Button>

                <UncontrolledTooltip placement="top" target={`backBtn`}>
                  Back
                </UncontrolledTooltip>
                <div>
                  <Button color="primary" className="" onClick={toggleModal}>
                    Upload Documents
                  </Button>
                </div>
              </div>
            </CardBody>
          </Card>
          <FileTable />
        </Container>

        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal} tag="h4">
            Upload File <i className="mdi mdi-file" />
          </ModalHeader>
          <ModalBody>
            {loading ? (
              <div className="w-100 text-center">
                <Spinner />
                <p>Please Wait.. File is uploading...</p>
              </div>
            ) : (
              <>
                <Input
                  type="file"
                  name="custFile"
                  id="custFileUpload"
                  onChange={e => setSelectedFile(e.target.files[0])}
                />
                <div className="my-2">
                  <Button
                    color="primary"
                    className="me-2"
                    onClick={handleUploadFile}
                  >
                    Upload
                  </Button>
                  <Button color="danger" className="me-2" onClick={toggleModal}>
                    Cancel
                  </Button>
                </div>
              </>
            )}
          </ModalBody>
        </Modal>

      </div>
      <ToastContainer />
    </React.Fragment>
  )
}

export default RefFiles
